import React, { useState, useEffect, useRef, useCallback } from 'react';
import Lenis from 'lenis';
import 'lenis/dist/lenis.css';
import './App.css';
import LightRays from './LightRays';
import ScrollReveal from './ScrollReveal';
import BorderGlow from './BorderGlow';
import DarkVeil from './DarkVeil';

/* ===== SVG ICONS ===== */
const Icons = {
  Shield: () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
    </svg>
  ),
  Lock: () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/>
    </svg>
  ),
  Heart: () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/>
    </svg>
  ),
  Video: () => (
    <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <polygon points="23 7 16 12 23 17 23 7"/><rect x="1" y="5" width="15" height="14" rx="2" ry="2"/>
    </svg>
  ),
  Camera: () => (
    <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"/><circle cx="12" cy="13" r="4"/>
    </svg>
  ),
  Mic: () => (
    <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <path d="M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z"/><path d="M19 10v2a7 7 0 0 1-14 0v-2"/><line x1="12" y1="19" x2="12" y2="23"/><line x1="8" y1="23" x2="16" y2="23"/>
    </svg>
  ),
  Edit: () => (
    <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/>
    </svg>
  ),
  Clock: () => (
    <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/>
    </svg>
  ),
  Gift: () => (
    <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="20 12 20 22 4 22 4 12"/><rect x="2" y="7" width="20" height="5"/><line x1="12" y1="22" x2="12" y2="7"/><path d="M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z"/><path d="M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z"/>
    </svg>
  ),
  Star: () => (
    <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/>
    </svg>
  ),
  Check: () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="20 6 9 17 4 12"/>
    </svg>
  ),
  Eye: () => (
    <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"/><line x1="1" y1="1" x2="23" y2="23"/>
    </svg>
  ),
  Users: () => (
    <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/>
    </svg>
  ),
  Plus: () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/>
    </svg>
  ),
  ArrowRight: () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/>
    </svg>
  ),
  Sparkle: () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <path d="M12 2l2.4 7.2L22 12l-7.6 2.8L12 22l-2.4-7.2L2 12l7.6-2.8z"/>
    </svg>
  ),
  Link: () => (
    <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"/><path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"/>
    </svg>
  ),
  QrCode: () => (
    <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <rect x="2" y="2" width="8" height="8" rx="1"/><rect x="14" y="2" width="8" height="8" rx="1"/><rect x="2" y="14" width="8" height="8" rx="1"/><rect x="14" y="14" width="4" height="4" rx="0.5"/><line x1="22" y1="14" x2="22" y2="14.01"/><line x1="22" y1="18" x2="22" y2="22"/><line x1="18" y1="22" x2="18" y2="22.01"/><line x1="14" y1="22" x2="14" y2="22.01"/>
    </svg>
  ),
  Nfc: () => (
    <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <path d="M6 8.32a7.43 7.43 0 0 1 0 7.36"/><path d="M9.46 6.21a11.76 11.76 0 0 1 0 11.58"/><path d="M12.91 4.1a16.07 16.07 0 0 1 0 15.8"/><path d="M16.37 2a20.38 20.38 0 0 1 0 20"/>
    </svg>
  ),
  Menu: () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <line x1="3" y1="6" x2="21" y2="6"/><line x1="3" y1="12" x2="21" y2="12"/><line x1="3" y1="18" x2="21" y2="18"/>
    </svg>
  ),
  Close: () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
    </svg>
  ),
};

/* ===== INTERSECTION OBSERVER HOOK ===== */
function useInView(options = {}) {
  const ref = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        setIsVisible(true);
        observer.unobserve(entry.target);
      }
    }, { threshold: 0.1, ...options });

    const current = ref.current;
    if (current) observer.observe(current);
    return () => { if (current) observer.unobserve(current); };
  }, [options]);

  return [ref, isVisible];
}

function AnimateIn({ children, delay = 0, className = '' }) {
  const [ref, isVisible] = useInView();
  return (
    <div
      ref={ref}
      className={`animate-in ${isVisible ? 'visible' : ''} ${className}`}
      style={{ transitionDelay: `${delay}ms` }}
    >
      {children}
    </div>
  );
}

/* ===== NAVBAR ===== */
function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handler = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handler, { passive: true });
    return () => window.removeEventListener('scroll', handler);
  }, []);

  useEffect(() => {
    if (menuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => { document.body.style.overflow = ''; };
  }, [menuOpen]);

  const closeMenu = () => setMenuOpen(false);

  const navLinks = [
    { href: '#what', label: 'What you get' },
    { href: '#how', label: 'How it works' },
    { href: '#story', label: 'Our story' },
    { href: '#privacy', label: 'Safety' },
    { href: '#faq', label: 'FAQ' },
  ];

  return (
    <>
      <nav className={`navbar ${scrolled ? 'scrolled' : ''}`}>
        <div className="container">
          <a href="#hero" className="navbar__logo">
            <img src="/iconnew.jpeg" alt="" className="navbar__logo-icon" />Capsule<span>.</span>
          </a>
          <div className="navbar__links">
            {navLinks.map((link) => (
              <a key={link.href} href={link.href} className="navbar__link">
                {link.label}
              </a>
            ))}
          </div>
          <div className="navbar__right">
            <div className="navbar__cta">
              <a href="#pricing" className="btn btn--primary">
                Buy capsule
              </a>
            </div>
            <button
              className="navbar__hamburger"
              onClick={() => setMenuOpen(true)}
              aria-label="Open menu"
            >
              <Icons.Menu />
            </button>
          </div>
        </div>
      </nav>

      {/* Mobile menu overlay */}
      <div className={`mobile-menu ${menuOpen ? 'open' : ''}`}>
        <div className="mobile-menu__header">
          <a href="#hero" className="navbar__logo" onClick={closeMenu}>
            <img src="/iconnew.jpeg" alt="" className="navbar__logo-icon" />Capsule<span>.</span>
          </a>
          <button
            className="mobile-menu__close"
            onClick={closeMenu}
            aria-label="Close menu"
          >
            <Icons.Close />
          </button>
        </div>
        <div className="mobile-menu__links">
          {navLinks.map((link) => (
            <a key={link.href} href={link.href} className="mobile-menu__link" onClick={closeMenu}>
              {link.label}
            </a>
          ))}
        </div>
        <div className="mobile-menu__cta">
          <a href="#pricing" className="btn btn--primary btn--large" onClick={closeMenu}>
            Create your capsule <Icons.ArrowRight />
          </a>
        </div>
      </div>
    </>
  );
}

/* ===== HERO ===== */
function Hero() {
  return (
    <section className="hero" id="hero">
      <div className="hero__rays">
        <LightRays
          raysOrigin="top-center"
          raysColor="#6fcf97"
          raysSpeed={0.25}
          lightSpread={2.5}
          rayLength={4.0}
          fadeDistance={3.0}
          saturation={0.7}
          followMouse={true}
          mouseInfluence={0.2}
        />
      </div>
      <div className="container">
        <div className="hero__content">
          <div className="hero__badge">
            <img src="/iconnew.jpeg" alt="" className="hero__badge-icon" /> Child Capsule
          </div>
          <h1 className="hero__title">
            A private capsule with memories and messages that open over time
          </h1>
          <p className="hero__subtitle">
            Create a private digital space where you store videos, photos, voice messages and letters for your child. Some chapters open now, others at 14, 18 or 22.
          </p>
          <div className="hero__actions">
            <a href="#pricing" className="hero__cta-card">
              <div className="hero__cta-left">
                <span className="hero__cta-label">Create your capsule</span>
                <span className="hero__cta-sub">Instant access after payment</span>
              </div>
              <div className="hero__cta-divider"></div>
              <div className="hero__cta-right">
                <span className="hero__cta-old">&euro;69</span>
                <span className="hero__cta-price">&euro;39</span>
              </div>
              <div className="hero__cta-arrow"><Icons.ArrowRight /></div>
            </a>
            <a href="#how" className="btn btn--secondary" style={{ marginTop: '12px' }}>
              How it works
            </a>
          </div>
          <div className="hero__trust">
            <div className="hero__trust-item">
              <Icons.Shield />
              <span>End-to-end encrypted</span>
            </div>
            <div className="hero__trust-item">
              <Icons.Lock />
              <span>One-time payment, no subscription</span>
            </div>
            <div className="hero__trust-item">
              <Icons.Heart />
              <span>Instant access after purchase</span>
            </div>
          </div>
        </div>
        <div className="hero__image">
          <div className="hero__image-wrapper">
            <img
              src="https://images.unsplash.com/photo-1491013516836-7db643ee125a?w=800&q=80&auto=format"
              alt="Parent holding child's hand"
              loading="eager"
            />
          </div>
          <div className="hero__image-float">
            <div className="hero__float-icon">
              <Icons.Heart />
            </div>
            <div className="hero__float-text">
              <strong>More than a gift</strong>
              A gift that grows in value
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

/* ===== WHAT YOU GET ===== */
function WhatYouGet() {
  const items = [
    { icon: <Icons.Lock />, text: 'Private digital capsule, end-to-end encrypted' },
    { icon: <Icons.Clock />, text: 'Unlimited chapters. Some for now, others for the future' },
    { icon: <Icons.Video />, text: 'Space for videos, photos, voice messages and letters' },
    { icon: <Icons.Star />, text: 'Choose when each chapter opens: now, at 14, 18 or 22' },
    { icon: <Icons.QrCode />, text: 'Unique QR code to give as a gift' },
    { icon: <Icons.Link />, text: 'Access from any device, no app needed' },
    { icon: <Icons.Shield />, text: '1 GB storage included' },
    { icon: <Icons.Heart />, text: '100-year preservation guarantee' },
  ];

  return (
    <section className="section section--beige" id="what">
      <div className="container">
        <AnimateIn>
          <div className="text-center" style={{ marginBottom: '56px' }}>
            <ScrollReveal tag="p" containerClassName="subtitle" enableBlur={true} baseOpacity={0.1} blurStrength={2} baseRotation={1}>What you get</ScrollReveal>
            <ScrollReveal enableBlur={true} baseOpacity={0.15} blurStrength={3} baseRotation={2}>Everything you need, in one place</ScrollReveal>
            <p style={{ maxWidth: '560px', margin: '16px auto 0', color: '#6a645c', fontSize: '1.08rem', lineHeight: 1.7 }}>
              After purchase, you get instant access to your private capsule. Set it up in minutes and start adding content right away.
            </p>
          </div>
        </AnimateIn>
        <div className="wyg-grid">
          {items.map((item, i) => (
            <AnimateIn key={i} delay={80 * i}>
              <div className="wyg-card">
                <div className="wyg-card__icon">{item.icon}</div>
                <p className="wyg-card__text">{item.text}</p>
              </div>
            </AnimateIn>
          ))}
        </div>
      </div>
    </section>
  );
}

/* ===== HOW IT WORKS ===== */
function HowItWorks() {
  const steps = [
    { icon: '✦', title: 'Buy the capsule', desc: 'Make the payment and get instant access to your private capsule.' },
    { icon: '♡', title: 'Add content', desc: 'Upload videos, photos, voice messages, or letters.' },
    { icon: '◎', title: 'Choose when they open', desc: 'Set each chapter to open now or at an important age.' },
    { icon: '✧', title: 'Give as a gift', desc: 'Give the capsule to the child or loved one you created it for.' },
  ];

  return (
    <section className="section" id="how">
      <div className="container text-center">
        <AnimateIn>
          <ScrollReveal tag="p" containerClassName="subtitle" enableBlur={true} baseOpacity={0.1} blurStrength={2} baseRotation={1}>How it works</ScrollReveal>
          <ScrollReveal enableBlur={true} baseOpacity={0.15} blurStrength={3} baseRotation={2}>4 simple steps</ScrollReveal>
        </AnimateIn>
        <div className="how-it-works__steps">
          {steps.map((step, i) => (
            <AnimateIn key={i} delay={i * 150}>
              <div className="step-card">
                <div className="step-card__number">
                  <span>{i + 1}</span>
                </div>
                <h3>{step.title}</h3>
                <p>{step.desc}</p>
              </div>
            </AnimateIn>
          ))}
        </div>
      </div>
    </section>
  );
}

/* ===== CONTENT TYPES + DEMO ===== */
function ContentTypes() {
  const items = [
    { icon: <Icons.Video />, title: 'Videos', desc: 'First steps, first words, unforgettable moments' },
    { icon: <Icons.Camera />, title: 'Photos', desc: 'Images that capture the emotion of every moment' },
    { icon: <Icons.Mic />, title: 'Voice messages', desc: 'Your voice, preserved forever' },
    { icon: <Icons.Edit />, title: 'Letters', desc: 'Thoughts written from the heart, for the future' },
  ];

  return (
    <section className="section" id="include">
      <div className="container">
        <div className="content-demo__grid">
          <AnimateIn>
            <div className="demo-video__wrapper">
              <video
                className="demo-video__player"
                autoPlay
                loop
                muted
                playsInline
                preload="auto"
              >
                <source src="/demo.mp4" type="video/mp4" />
              </video>
            </div>
          </AnimateIn>
          <AnimateIn delay={200}>
            <div className="content-demo__right">
              <ScrollReveal tag="p" containerClassName="subtitle" enableBlur={true} baseOpacity={0.1} blurStrength={2} baseRotation={1}>What you can include</ScrollReveal>
              <ScrollReveal enableBlur={true} baseOpacity={0.15} blurStrength={3} baseRotation={2}>Memories in any format</ScrollReveal>
              <p className="content-demo__intro">
                Each capsule becomes a unique collection of authentic moments, organized into chapters that your child will discover over time.
              </p>
              <div className="content-demo__items">
                {items.map((item, i) => (
                  <div className="content-demo__item" key={i}>
                    <div className="content-demo__item-icon">{item.icon}</div>
                    <div>
                      <h3>{item.title}</h3>
                      <p>{item.desc}</p>
                    </div>
                  </div>
                ))}
              </div>
              <a href="https://eternix.io/c/demo_en" target="_blank" rel="noopener noreferrer" className="demo-card">
                <div className="demo-card__body">
                  <span className="demo-card__title">Try a live demo</span>
                  <span className="demo-card__pass">password: <strong>demo</strong></span>
                </div>
                <div className="demo-card__arrow"><Icons.ArrowRight /></div>
              </a>
            </div>
          </AnimateIn>
        </div>
      </div>
    </section>
  );
}

/* ===== WHY IT'S DIFFERENT ===== */
function WhySpecial() {
  const features = [
    {
      title: 'Chapters that open over time',
      desc: 'You choose what can be seen now and what stays for later, at 14, 18 or 22. Your child discovers new messages at the important moments in life.',
    },
    {
      title: 'A gift with real value',
      desc: 'In a world full of short-lived toys and forgotten gifts, you give something authentic, personal and truly memorable.',
    },
    {
      title: 'From anyone, for the child',
      desc: 'Parents, grandparents, godparents, close friends. Everyone can add messages and memories to the capsule.',
    },
    {
      title: 'Grows in value over time',
      desc: 'The more time passes, the more precious the capsule becomes. It is a gift that does not depreciate. It gains meaning.',
    },
  ];

  return (
    <section className="section section--beige" id="special">
      <div className="container">
        <div className="text-center">
          <AnimateIn>
            <ScrollReveal tag="p" containerClassName="subtitle" enableBlur={true} baseOpacity={0.1} blurStrength={2} baseRotation={1}>Why it's different</ScrollReveal>
            <ScrollReveal enableBlur={true} baseOpacity={0.15} blurStrength={3} baseRotation={2}>Not just a gift. A gift that grows in value.</ScrollReveal>
            <div className="divider"></div>
          </AnimateIn>
        </div>
        <div className="why-special__grid">
          <AnimateIn>
            <div className="why-special__features">
              {features.map((f, i) => (
                <div className="feature-item" key={i}>
                  <div className="feature-item__number">{i + 1}</div>
                  <div className="feature-item__content">
                    <h3>{f.title}</h3>
                    <p>{f.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </AnimateIn>
          <AnimateIn delay={200}>
            <div className="why-special__image">
              <img
                src="https://images.unsplash.com/photo-1476703993599-0035a21b17a9?w=700&q=80&auto=format"
                alt="Grandparents with grandchildren"
                loading="lazy"
              />
            </div>
          </AnimateIn>
        </div>
      </div>
    </section>
  );
}

/* ===== OCCASIONS ===== */
function Occasions() {
  const items = [
    { title: 'At birth', desc: 'A welcome gift, full of emotion and promises' },
    { title: 'At christening', desc: 'The perfect gift from godparents, grandparents or close friends' },
    { title: 'First birthday', desc: 'A collection of memories from the first year of life' },
    { title: 'From grandparents', desc: 'Their voice and their stories, preserved for generations' },
    { title: 'From godparents', desc: 'An authentic gesture, with meaning and real value' },
    { title: 'For the future', desc: 'Messages and thoughts that will reach your child at the right moment' },
  ];

  return (
    <section className="section" id="occasions">
      <div className="container">
        <div className="text-center">
          <AnimateIn>
            <ScrollReveal tag="p" containerClassName="subtitle" enableBlur={true} baseOpacity={0.1} blurStrength={2} baseRotation={1}>Perfect for</ScrollReveal>
            <ScrollReveal enableBlur={true} baseOpacity={0.15} blurStrength={3} baseRotation={2}>The right gift for every important moment</ScrollReveal>
          </AnimateIn>
        </div>
        <div className="occasions__grid">
          {items.map((item, i) => (
            <AnimateIn key={i} delay={i * 80}>
              <div className="occasion-card">
                <span className="occasion-card__icon"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><circle cx="12" cy="12" r="10"/></svg></span>
                <div>
                  <h3>{item.title}</h3>
                  <p>{item.desc}</p>
                </div>
              </div>
            </AnimateIn>
          ))}
        </div>
      </div>
    </section>
  );
}

/* ===== FOUNDER STORY ===== */
function FounderStory() {
  return (
    <section className="founder-story" id="story">
      <div className="founder-story__bg">
        <img
          src="https://images.pexels.com/photos/13975850/pexels-photo-13975850.jpeg?auto=compress&cs=tinysrgb&w=1200"
          alt="Father kissing newborn daughter"
          loading="lazy"
        />
        <div className="founder-story__bg-overlay"></div>
      </div>
      <div className="container">
        <div className="founder-story__wrapper">
          <AnimateIn>
            <p className="founder-story__label">The story behind Eternix</p>
          </AnimateIn>
          <AnimateIn delay={150}>
            <h2 className="founder-story__quote">
              "I wanted to leave them something that would last, even if I wouldn't"
            </h2>
          </AnimateIn>
          <AnimateIn delay={300}>
            <div className="founder-story__body">
              <p>
                It all started on a day when life stopped for a few moments. I had a heart attack. I have two little girls, one aged 2 and one aged 9. In those moments of forced silence, a single thought overwhelmed me: I hadn't told them everything I wanted to say.
              </p>
              <p>
                I thought about all the things I'd want to share when they turn 14, 18, 22. Advice, stories, confessions, encouragement. I realized how fragile everything is and how easily the most important things can be left unsaid.
              </p>
              <p>
                That's how the idea for Eternix was born: a private, intimate digital space where a parent can leave messages that open at the right moment. Not a will. Not a letter in a drawer. But a living gift that reaches your child exactly when they need it.
              </p>
            </div>
          </AnimateIn>
          <AnimateIn delay={450}>
            <p className="founder-story__closing">
              The Child Capsule exists because love shouldn't depend on time.
            </p>
          </AnimateIn>
        </div>
      </div>
    </section>
  );
}

/* ===== PRIVACY ===== */
function Privacy() {
  const items = [
    {
      icon: <Icons.Shield />,
      title: 'End-to-end encryption',
      desc: 'All content is encrypted before it reaches our servers. No one can see what\'s inside.',
    },
    {
      icon: <Icons.Eye />,
      title: 'Not even Eternix can see',
      desc: 'We use a zero-knowledge architecture. We have no access to your content, even if we wanted to.',
    },
    {
      icon: <Icons.Users />,
      title: 'Only the people you choose',
      desc: 'You decide who has access. Content remains completely private and protected.',
    },
  ];

  return (
    <section className="section section--beige privacy" id="privacy">
      <div className="container text-center">
        <AnimateIn>
          <ScrollReveal tag="p" containerClassName="subtitle" enableBlur={true} baseOpacity={0.1} blurStrength={2} baseRotation={1}>Safety and privacy</ScrollReveal>
          <ScrollReveal enableBlur={true} baseOpacity={0.15} blurStrength={3} baseRotation={2}>Your content is private. Period.</ScrollReveal>
        </AnimateIn>
        <div className="privacy__grid">
          {items.map((item, i) => (
            <AnimateIn key={i} delay={i * 150}>
              <div className="privacy-card">
                <div className="privacy-card__icon">{item.icon}</div>
                <h3>{item.title}</h3>
                <p>{item.desc}</p>
              </div>
            </AnimateIn>
          ))}
        </div>
      </div>
    </section>
  );
}

/* ===== PRICING ===== */
function Pricing() {
  const included = [
    'Private capsule, end-to-end encrypted',
    'Videos, photos, voice messages, letters',
    'Chapters with scheduled opening',
    '1 GB storage',
    'Access from any device',
    '100-year preservation guarantee',
  ];

  return (
    <section className="pricing-section" id="pricing">
      <div className="pricing-section__veil">
        <DarkVeil speed={0.8} hueShift={155} noiseIntensity={0.02} />
      </div>
      <div className="container" style={{ position: 'relative', zIndex: 2 }}>
        <AnimateIn>
          <div className="pricing-section__header">
            <ScrollReveal tag="p" containerClassName="subtitle" enableBlur={true} baseOpacity={0.1} blurStrength={2} baseRotation={1}>Child Capsule</ScrollReveal>
            <ScrollReveal enableBlur={true} baseOpacity={0.15} blurStrength={3} baseRotation={2}>Choose the right option for you.</ScrollReveal>
          </div>

          <div className="pricing-section__cards">
            {/* Digital */}
            <BorderGlow
              edgeSensitivity={25}
              glowColor="140 60 70"
              backgroundColor="rgba(20, 18, 16, 0.9)"
              borderRadius={20}
              glowRadius={30}
              glowIntensity={0.8}
              coneSpread={20}
              colors={['#9dc4af', '#82b399', '#b8d9c7']}
              fillOpacity={0.3}
            >
              <div className="pricing-section__card">
                <span className="pricing-section__badge">Digital</span>
                <div className="pricing-section__price">
                  <span className="pricing-section__old">&euro;69</span>
                  <span className="pricing-section__amount">39</span>
                  <span className="pricing-section__currency">&euro;</span>
                </div>
                <p className="pricing-section__card-desc">Get your capsule instantly via email. Everything online, simple and fast.</p>
                <ul className="pricing-section__card-list">
                  {included.map((item, i) => (
                    <li key={i}><Icons.Check /><span>{item}</span></li>
                  ))}
                  <li><Icons.Check /><span>Instant delivery via email</span></li>
                  <li><Icons.Check /><span>Digital QR code for gifting</span></li>
                </ul>
                <a href="https://buy.stripe.com/cNi5kE7Xy1sda8C0r6aIM0c" target="_blank" rel="noopener noreferrer" className="pricing-section__btn" onClick={() => window.gtag_report_conversion()}>
                  Buy digital <Icons.ArrowRight />
                </a>
                <p className="pricing-section__note">One-time payment. No subscription.</p>
              </div>
            </BorderGlow>

          </div>
        </AnimateIn>
      </div>
    </section>
  );
}

/* ===== TESTIMONIALS ===== */
function Testimonials() {
  const items = [
    {
      text: 'We created a capsule for our daughter when she was just a few days old. We added the first photos, the first voice messages, letters for the future. I know that one day she\'ll open everything and feel how loved she was from the very first moment.',
      name: 'Sarah M.',
      role: 'Mother, London',
      initials: 'SM',
    },
    {
      text: 'As a grandfather, I wanted to leave my grandson something truly valuable. I recorded stories, advice, and memories from my life. The capsule is the most personal gift I\'ve ever given.',
      name: 'James P.',
      role: 'Grandfather, Manchester',
      initials: 'JP',
    },
    {
      text: 'We were godparents at the christening and we were looking for a gift that had real meaning. The capsule was the perfect choice. We added our message and chose for it to open when he turns 18.',
      name: 'Emily & David',
      role: 'Godparents, Edinburgh',
      initials: 'ED',
    },
  ];

  return (
    <section className="section section--beige" id="testimonials">
      <div className="container">
        <div className="text-center">
          <AnimateIn>
            <ScrollReveal tag="p" containerClassName="subtitle" enableBlur={true} baseOpacity={0.1} blurStrength={2} baseRotation={1}>Real experiences</ScrollReveal>
            <ScrollReveal enableBlur={true} baseOpacity={0.15} blurStrength={3} baseRotation={2}>What parents and families say</ScrollReveal>
            <div className="divider"></div>
          </AnimateIn>
        </div>
        <div className="testimonials__grid">
          {items.map((item, i) => (
            <AnimateIn key={i} delay={i * 150}>
              <div className="testimonial-card">
                <div className="testimonial-card__stars">{'\u2605\u2605\u2605\u2605\u2605'}</div>
                <p className="testimonial-card__text">"{item.text}"</p>
                <div className="testimonial-card__author">
                  <div className="testimonial-card__avatar">{item.initials}</div>
                  <div>
                    <div className="testimonial-card__name">{item.name}</div>
                    <div className="testimonial-card__role">{item.role}</div>
                  </div>
                </div>
              </div>
            </AnimateIn>
          ))}
        </div>
      </div>
    </section>
  );
}

/* ===== FAQ ===== */
function FAQ() {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggle = useCallback((index) => {
    setActiveIndex(prev => prev === index ? null : index);
  }, []);

  const items = [
    {
      q: 'What is the Child Capsule?',
      a: 'It is a private digital capsule where you can keep videos, photos, voice messages and letters for your child. Some chapters open now, others at important ages, at 14, 18 or 22.',
    },
    {
      q: 'What can I add to the capsule?',
      a: 'Videos, photos, voice messages and letters. You can organize everything into chapters and choose when each one opens.',
    },
    {
      q: 'Who can see the content?',
      a: 'Only the people you choose. The content is end-to-end encrypted, and Eternix cannot see what\'s inside.',
    },
    {
      q: 'Is it safe and private?',
      a: 'Yes. We use end-to-end encryption and a zero-knowledge architecture. Not even the Eternix team has access to your content.',
    },
    {
      q: 'Can I open some chapters now and others later?',
      a: 'Yes, that\'s exactly what makes the capsule special. You choose for each chapter whether it opens immediately or at a specific age.',
    },
    {
      q: 'What happens after I buy?',
      a: 'You immediately receive a private link to your capsule via email. You set it up, add content and choose when each chapter opens.',
    },
    {
      q: 'Is it suitable as a gift?',
      a: 'Absolutely. You receive a QR code that you can put in an envelope, a greeting card or a gift box. The perfect gift at birth, christening or a birthday.',
    },
    {
      q: 'Can I continue adding content over time?',
      a: 'Yes. The capsule is not a project you need to finish all at once. You can add memories anytime, over the years.',
    },
    {
      q: 'Do I need technical knowledge?',
      a: 'No. Everything is simple and intuitive. If you can use a phone, you can use the capsule.',
    },
    {
      q: 'How long is the content preserved?',
      a: 'We offer a 100-year preservation guarantee. Your content is safe for the long term.',
    },
  ];

  return (
    <section className="section" id="faq">
      <div className="container">
        <div className="text-center">
          <AnimateIn>
            <ScrollReveal enableBlur={true} baseOpacity={0.15} blurStrength={3} baseRotation={2}>Frequently asked questions</ScrollReveal>
            <div className="divider"></div>
          </AnimateIn>
        </div>
        <div className="faq__list">
          {items.map((item, i) => (
            <AnimateIn key={i} delay={i * 60}>
              <div className={`faq-item ${activeIndex === i ? 'active' : ''}`}>
                <button className="faq-item__question" onClick={() => toggle(i)}>
                  <h3>{item.q}</h3>
                  <div className="faq-item__toggle">
                    <Icons.Plus />
                  </div>
                </button>
                <div className="faq-item__answer">
                  <p>{item.a}</p>
                </div>
              </div>
            </AnimateIn>
          ))}
        </div>
      </div>
    </section>
  );
}

/* ===== FINAL CTA ===== */
function FinalCTA() {
  return (
    <section className="section final-cta" id="cta">
      <div className="container">
        <AnimateIn>
          <div className="final-cta__content">
            <ScrollReveal enableBlur={true} baseOpacity={0.15} blurStrength={3} baseRotation={2}>Start now. Create a capsule for your child.</ScrollReveal>
            <p>
              Some things should not be left unsaid. Turn them into chapters your child will open with emotion years from now.
            </p>
            <div className="final-cta__actions">
              <a href="#pricing" className="btn btn--primary btn--large">
                Create your capsule <Icons.ArrowRight />
              </a>
            </div>
            <p className="hero__trust" style={{ justifyContent: 'center', marginTop: '24px' }}>
              One-time payment | Instant access | End-to-end encrypted
            </p>
          </div>
        </AnimateIn>
      </div>
    </section>
  );
}

/* ===== FOOTER ===== */
function Footer() {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer__logo">
          <img src="/iconnew.jpeg" alt="" className="navbar__logo-icon" />Capsule<span>.</span>
        </div>
        <p className="footer__tagline">
          Memories, messages and moments preserved with meaning. An Eternix project.
        </p>
        <div className="footer__links">
          <a href="#what">What you get</a>
          <a href="#how">How it works</a>
          <a href="#privacy">Privacy</a>
          <a href="#faq">FAQ</a>
          <a href="mailto:contact@childcapsule.com">contact@childcapsule.com</a>
        </div>
        <div className="footer__divider"></div>
        <p className="footer__bottom">
          &copy; 2026 Child Capsule. A product by <a href="https://eternix.io" target="_blank" rel="noopener noreferrer">Eternix</a>. All rights reserved.
        </p>
      </div>
    </footer>
  );
}

/* ===== MOBILE STICKY CTA ===== */
function MobileCTA() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handler = () => setVisible(window.scrollY > 600);
    window.addEventListener('scroll', handler, { passive: true });
    return () => window.removeEventListener('scroll', handler);
  }, []);

  return (
    <div className={`mobile-cta ${visible ? 'visible' : ''}`}>
      <a href="#pricing" className="btn btn--primary">
        Create your capsule <Icons.ArrowRight />
      </a>
    </div>
  );
}

/* ===== ADMIN DASHBOARD ===== */
const ADMIN_API = 'https://jnbgdiaofymacfobgmcf.supabase.co/functions/v1/admin-api';

function Admin() {
  const [password, setPassword] = useState('');
  const [authed, setAuthed] = useState(false);
  const [stats, setStats] = useState(null);
  const [tab, setTab] = useState('dashboard');
  const [orders, setOrders] = useState([]);
  const [capsules, setCapsules] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const storedPw = useRef('');

  const api = useCallback(async (action, params = '') => {
    const res = await fetch(`${ADMIN_API}?action=${action}${params}`, {
      headers: { 'x-admin-password': storedPw.current },
    });
    if (res.status === 401) { setAuthed(false); throw new Error('Unauthorized'); }
    if (!res.ok) throw new Error('API error');
    return res.json();
  }, []);

  const login = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    storedPw.current = password;
    try {
      const data = await api('stats');
      setStats(data);
      setAuthed(true);
    } catch { setError('Incorrect password'); }
    setLoading(false);
  };

  const loadStats = useCallback(async () => {
    try { setStats(await api('stats')); } catch {}
  }, [api]);

  const loadOrders = useCallback(async () => {
    try { const d = await api('orders'); setOrders(d.orders); } catch {}
  }, [api]);

  const loadCapsules = useCallback(async (status = 'all', plan = 'all') => {
    try { const d = await api('capsules', `&status=${status}&plan=${plan}`); setCapsules(d.capsules); } catch {}
  }, [api]);

  useEffect(() => { if (authed && tab === 'dashboard') loadStats(); }, [authed, tab, loadStats]);
  useEffect(() => { if (authed && tab === 'orders') loadOrders(); }, [authed, tab, loadOrders]);
  useEffect(() => { if (authed && tab === 'capsules') loadCapsules(); }, [authed, tab, loadCapsules]);

  if (!authed) {
    return (
      <div className="admin-login">
        <form onSubmit={login}>
          <h2>Admin</h2>
          <input type="password" value={password} onChange={e => setPassword(e.target.value)} placeholder="Password" autoFocus />
          <button type="submit" disabled={loading}>{loading ? '...' : 'Log in'}</button>
          {error && <p className="admin-error">{error}</p>}
        </form>
      </div>
    );
  }

  const fmt = (v) => new Intl.NumberFormat('en-US').format(Math.round(v / 100));
  const fmtDate = (d) => d ? new Date(d).toLocaleString('en-US', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' }) : '\u2014';

  return (
    <div className="admin">
      <div className="admin-header">
        <h1>Child Capsule — Admin</h1>
        <div className="admin-tabs">
          <button className={tab === 'dashboard' ? 'active' : ''} onClick={() => setTab('dashboard')}>Dashboard</button>
          <button className={tab === 'orders' ? 'active' : ''} onClick={() => setTab('orders')}>Orders</button>
          <button className={tab === 'capsules' ? 'active' : ''} onClick={() => setTab('capsules')}>Capsules</button>
        </div>
      </div>

      {tab === 'dashboard' && stats && (
        <div className="admin-content">
          <div className="admin-stats">
            <div className="admin-stat">
              <span className="admin-stat__value">{stats.totalOrders}</span>
              <span className="admin-stat__label">Total orders</span>
            </div>
            <div className="admin-stat">
              <span className="admin-stat__value">${fmt(stats.totalRevenue)}</span>
              <span className="admin-stat__label">Total revenue</span>
            </div>
            <div className="admin-stat">
              <span className="admin-stat__value">{stats.todayOrderCount}</span>
              <span className="admin-stat__label">Orders today</span>
            </div>
            <div className="admin-stat">
              <span className="admin-stat__value">${fmt(stats.todayRevenue)}</span>
              <span className="admin-stat__label">Revenue today</span>
            </div>
          </div>

          <h3>Capsule inventory</h3>
          <table className="admin-table">
            <thead><tr><th>Plan</th><th>Available</th><th>Sold</th><th>Total</th></tr></thead>
            <tbody>
              {stats.inventory.map((r, i) => (
                <tr key={i}>
                  <td><span className={`admin-badge admin-badge--${r.plan}`}>{r.plan}</span></td>
                  <td className={r.available < 50 ? 'admin-warn' : ''}>{r.available}</td>
                  <td>{r.sold}</td>
                  <td>{r.total}</td>
                </tr>
              ))}
            </tbody>
          </table>

          <h3>Recent orders</h3>
          <table className="admin-table">
            <thead><tr><th>Date</th><th>Email</th><th>Name</th><th>Plan</th><th>Amount</th><th>Email sent</th></tr></thead>
            <tbody>
              {stats.recentOrders.map((o, i) => (
                <tr key={i}>
                  <td>{fmtDate(o.created_at)}</td>
                  <td>{o.buyer_email}</td>
                  <td>{o.buyer_name || '\u2014'}</td>
                  <td><span className={`admin-badge admin-badge--${o.plan}`}>{o.plan}</span></td>
                  <td>${fmt(o.amount)}</td>
                  <td>{o.email_sent ? '\u2713' : '\u2717'}</td>
                </tr>
              ))}
              {stats.recentOrders.length === 0 && <tr><td colSpan="6" style={{textAlign:'center',color:'#a09890'}}>No orders yet</td></tr>}
            </tbody>
          </table>
          <button className="admin-refresh" onClick={loadStats}>Refresh</button>
        </div>
      )}

      {tab === 'orders' && (
        <div className="admin-content">
          <h3>All orders</h3>
          <table className="admin-table">
            <thead><tr><th>Date</th><th>Email</th><th>Name</th><th>Plan</th><th>Amount</th><th>Email</th><th>Stripe</th></tr></thead>
            <tbody>
              {orders.map((o, i) => (
                <tr key={i}>
                  <td>{fmtDate(o.created_at)}</td>
                  <td>{o.buyer_email}</td>
                  <td>{o.buyer_name || '\u2014'}</td>
                  <td><span className={`admin-badge admin-badge--${o.plan}`}>{o.plan}</span></td>
                  <td>${fmt(o.amount)}</td>
                  <td>{o.email_sent ? '\u2713' : '\u2717'}</td>
                  <td style={{fontSize:'0.7rem',maxWidth:120,overflow:'hidden',textOverflow:'ellipsis'}}>{o.stripe_session_id}</td>
                </tr>
              ))}
            </tbody>
          </table>
          <button className="admin-refresh" onClick={loadOrders}>Refresh</button>
        </div>
      )}

      {tab === 'capsules' && (
        <div className="admin-content">
          <h3>Capsules</h3>
          <div className="admin-filters">
            <button onClick={() => loadCapsules('all','all')}>All</button>
            <button onClick={() => loadCapsules('available','all')}>Available</button>
            <button onClick={() => loadCapsules('sold','all')}>Sold</button>
            <button onClick={() => loadCapsules('all','digital')}>Digital</button>
            <button onClick={() => loadCapsules('all','premium')}>Premium</button>
          </div>
          <table className="admin-table">
            <thead><tr><th>Status</th><th>Plan</th><th>URL</th><th>Buyer</th><th>Sold at</th></tr></thead>
            <tbody>
              {capsules.map((c, i) => (
                <tr key={i}>
                  <td><span className={`admin-badge admin-badge--${c.status}`}>{c.status}</span></td>
                  <td><span className={`admin-badge admin-badge--${c.plan}`}>{c.plan}</span></td>
                  <td style={{maxWidth:200,overflow:'hidden',textOverflow:'ellipsis'}}><a href={c.capsule_url} target="_blank" rel="noopener noreferrer">{c.capsule_url}</a></td>
                  <td>{c.buyer_email || '\u2014'}</td>
                  <td>{fmtDate(c.sold_at)}</td>
                </tr>
              ))}
            </tbody>
          </table>
          <button className="admin-refresh" onClick={() => loadCapsules()}>Refresh</button>
        </div>
      )}
    </div>
  );
}

/* ===== KEYWORD LANDING PAGES ===== */
const LANDING_PAGES = {
  '/gifts-for-kids': {
    title: 'Gifts for Kids — A gift that lasts',
    metaDesc: 'Looking for a special gift for a child? Child Capsule is a unique digital gift — memories, messages and moments preserved forever.',
    badge: 'Gifts for kids',
    headline: <>The most beautiful gift<br/>for a&nbsp;<em>child</em></>,
    subtitle: 'Not a toy that\'s forgotten tomorrow. But an emotional gift that grows in value — a private capsule with memories, voice messages and letters for the future.',
  },
  '/christening-gifts': {
    title: 'Christening Gifts — A unique gift from godparents',
    metaDesc: 'The most special christening gift: a digital capsule with messages, memories and wishes that open over time. A gift with real meaning from godparents.',
    badge: 'Christening gifts',
    headline: <>The most special gift<br/>for a&nbsp;<em>christening</em></>,
    subtitle: 'A gift from godparents that\'s like nothing else. A private capsule where you leave messages, wishes and memories that your godchild will discover throughout their life.',
  },
  '/godparent-gifts': {
    title: 'Gifts from Godparents — More than a tradition',
    metaDesc: 'The perfect gift from godparents: a digital capsule with personal messages, photos and wishes. An emotional gift that grows in value over time.',
    badge: 'Gifts from godparents',
    headline: <>A gift from godparents<br/>that lasts&nbsp;<em>forever</em></>,
    subtitle: 'More than a tradition. A private capsule where you leave messages, advice and memories that your godchild will cherish for a lifetime.',
  },
  '/grandparent-gifts': {
    title: 'Gifts for Grandchildren — From grandparents, with love',
    metaDesc: 'The most valuable gift grandparents can leave their grandchildren: a capsule with their voice, their stories and their love — preserved forever.',
    badge: 'Gifts for grandchildren',
    headline: <>From grandparents,<br/>with&nbsp;<em>love</em></>,
    subtitle: 'One day your grandchildren would give anything to hear their grandparents\' voice again. Child Capsule preserves the stories, advice and love — forever.',
  },
  '/gift-ideas': {
    title: 'Unique Gift Ideas — A gift with real meaning',
    metaDesc: 'Looking for a truly special gift idea? Child Capsule is an emotional digital gift — memories and messages preserved for a lifetime.',
    badge: 'Gift ideas',
    headline: <>A gift they'll never<br/>&nbsp;<em>forget</em></>,
    subtitle: 'When you want to give something truly special, not a toy or an object. But an emotional gift — a capsule with memories, messages and moments that last.',
  },
  '/newborn-gifts': {
    title: 'Gifts for Newborns — The first heartfelt gift',
    metaDesc: 'The most emotional gift for a newborn: a private digital capsule with messages, photos and memories from the very first day of life.',
    badge: 'Newborn gifts',
    headline: <>The first heartfelt gift<br/>for a&nbsp;<em>newborn</em></>,
    subtitle: 'From the very first day of life, start building a treasure of memories. Your voice, the first photos, family wishes — all in a private capsule that will be waiting for them.',
  },
  '/gifts-from-dad': {
    title: 'Gifts from Dad — Messages that last forever',
    metaDesc: 'The most personal gift a father can leave his child: a capsule with his voice, his advice and his love — preserved for a lifetime.',
    badge: 'Gifts from dad',
    headline: <>From dad,<br/>&nbsp;<em>forever</em></>,
    subtitle: 'One day your child would give anything to hear your voice just one more time. Leave them your voice, your advice, your stories — in a capsule they\'ll treasure for a lifetime.',
  },
  '/birthday-gifts': {
    title: 'Birthday Gift — A gift that\'s never forgotten',
    metaDesc: 'Looking for a special birthday gift? Child Capsule is a unique gift — memories, messages and moments preserved forever.',
    badge: 'Birthday gift',
    headline: <>A birthday gift<br/>that's never&nbsp;<em>forgotten</em></>,
    subtitle: 'Not a toy that breaks tomorrow. But a gift that grows in value — a capsule with messages, memories and surprises that open over time.',
  },
  '/anniversary-gifts': {
    title: 'Anniversary Gift — A truly unique emotional gift',
    metaDesc: 'The most beautiful anniversary gift: a digital capsule with messages, photos and memories. A personal gift that grows in value every year.',
    badge: 'Anniversary gift',
    headline: <>The most beautiful gift<br/>for an&nbsp;<em>anniversary</em></>,
    subtitle: 'With every anniversary, the capsule becomes more valuable. Add new messages, new memories — a gift that grows with your child.',
  },
};

function LandingPage({ config }) {
  useEffect(() => {
    document.title = config.title;
    const metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) metaDesc.setAttribute('content', config.metaDesc);
    const ogTitle = document.querySelector('meta[property="og:title"]');
    if (ogTitle) ogTitle.setAttribute('content', config.title);
    const ogDesc = document.querySelector('meta[property="og:description"]');
    if (ogDesc) ogDesc.setAttribute('content', config.metaDesc);
  }, [config]);

  return (
    <>
      <Navbar />
      <section className="hero" id="hero">
        <div className="container">
          <div className="hero__content">
            <div className="hero__badge">
              <img src="/iconnew.jpeg" alt="" className="hero__badge-icon" /> {config.badge}
            </div>
            <h1 className="hero__title">
              {config.headline}
            </h1>
            <p className="hero__subtitle">
              {config.subtitle}
            </p>
            <div className="hero__actions">
              <a href="#pricing" className="btn btn--primary btn--large">
                Buy capsule <Icons.ArrowRight />
              </a>
              <a href="#how" className="btn btn--secondary">
                How it works
              </a>
            </div>
            <div className="hero__trust">
              <div className="hero__trust-item">
                <Icons.Shield />
                <span>End-to-end encrypted</span>
              </div>
              <div className="hero__trust-item">
                <Icons.Lock />
                <span>100% private</span>
              </div>
              <div className="hero__trust-item">
                <Icons.Heart />
                <span>Made with love</span>
              </div>
            </div>
          </div>
          <div className="hero__image">
            <div className="hero__image-wrapper">
              <img
                src="https://images.unsplash.com/photo-1491013516836-7db643ee125a?w=800&q=80&auto=format"
                alt="Happy family"
                loading="eager"
              />
            </div>
          </div>
        </div>
      </section>
      <WhatYouGet />
      <HowItWorks />
      <ContentTypes />
      <WhySpecial />
      <Occasions />
      <FounderStory />
      <Privacy />
      <Pricing />
      <Testimonials />
      <FAQ />
      <FinalCTA />
      <Footer />
      <MobileCTA />
    </>
  );
}

/* ===== THANK YOU PAGE ===== */
function ThankYou() {
  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'linear-gradient(175deg, #ffffff 0%, #faf8f5 50%, #f2ece4 100%)' }}>
      <div style={{ textAlign: 'center', maxWidth: 520, padding: '40px 24px' }}>
        <div style={{ width: 72, height: 72, margin: '0 auto 28px', background: 'linear-gradient(135deg, #9dc4af, #b8d9c7)', borderRadius: 20, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <Icons.Heart />
        </div>
        <h1 style={{ fontFamily: "'Playfair Display', serif", fontSize: '2.2rem', color: '#1a1815', marginBottom: 16 }}>
          Thank you from the heart!
        </h1>
        <p style={{ fontSize: '1.1rem', color: '#8a847b', lineHeight: 1.8, marginBottom: 32 }}>
          Your capsule has been created successfully. You will receive an email
          shortly with your capsule link and instructions.
        </p>
        <p style={{ fontSize: '0.95rem', color: '#a09890', lineHeight: 1.7, marginBottom: 40 }}>
          Please also check your spam folder if you don't receive the email within 5 minutes.
        </p>
        <a href="/" className="btn btn--primary btn--large">
          Back to homepage <Icons.ArrowRight />
        </a>
      </div>
    </div>
  );
}

/* ===== APP ===== */
function App() {
  const pathname = window.location.pathname;
  const isThankYou = pathname === '/thank-you';
  const isAdmin = pathname === '/admin';
  const landingConfig = LANDING_PAGES[pathname];

  useEffect(() => {
    if (isThankYou || isAdmin || landingConfig) return;
    const lenis = new Lenis({
      autoRaf: false,
      duration: 1.2,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      orientation: 'vertical',
    });

    function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }
    requestAnimationFrame(raf);

    return () => lenis.destroy();
  }, [isThankYou, isAdmin, landingConfig]);

  if (isAdmin) {
    return <Admin />;
  }

  if (isThankYou) {
    return <ThankYou />;
  }

  if (landingConfig) {
    return <LandingPage config={landingConfig} />;
  }

  return (
    <>
      <Navbar />
      <Hero />
      <WhatYouGet />
      <HowItWorks />
      <ContentTypes />
      <WhySpecial />
      <Occasions />
      <FounderStory />
      <Privacy />
      <Pricing />
      <Testimonials />
      <FAQ />
      <FinalCTA />
      <Footer />
      <MobileCTA />
    </>
  );
}

export default App;
